// extracted by mini-css-extract-plugin
export default {"container":"RegisterTemplatePage_container__vy0Sl","banner":"RegisterTemplatePage_banner__iS616","logoContainer":"RegisterTemplatePage_logoContainer__aoRVJ"};